// Generated by CoffeeScript 2.7.0
var FileUploader;

import Ajax from './ajax.js';

export default FileUploader = class FileUploader {
  // https://gist.github.com/ghinda/8442a57f22099bdb2e34
  static objectToFormData(obj, formData, namespace) {
    var fd, formKey;
    fd = formData || new FormData();
    formKey = void 0;
    _.each(obj, (val, property) => {
      if (_.has(obj, property)) {
        formKey = namespace ? namespace + '[' + property + ']' : property;
        // if the property is an object, but not a File,
        // use recursivity.
        if (typeof val === 'object' && !(val instanceof File)) {
          return this.objectToFormData(val, fd, property);
        } else {
          // if it's a string or a File object
          return fd.append(formKey, val);
        }
      }
    });
    return fd;
  }

  constructor(url, param_name = 'file', options = {}) {
    this.url = url;
    this.param_name = param_name;
    this.options = options;
    this.options = _.extend({
      method: 'post',
      contentType: false
    }, this.options);
  }

  // return an ajax instance,
  // so you can chain with it.
  upload(file, data = {}) {
    var formData;
    if (_.isObject(file) && !(file instanceof File)) {
      data = file;
    } else {
      data[this.param_name] = file;
    }
    formData = this.constructor.objectToFormData(data);
    return new Ajax(this.url, _.extend({}, this.options, {
      data: formData
    }));
  }

};
